


















import { Vue, Component, Prop } from "vue-property-decorator";
import { timeFormatTime, HTMLEncode } from "../../../utils/index"
enum READ_STATUS {
  NOT_READ = 3,
  READ = 4
}
@Component({
  name: "WhatsappDialogue"
})
export default class WhatsappDialogue extends Vue {
  private created() { }
  @Prop({
    default: {
      showname: '',
      recvmobile: '',
      islogin: 0,
      lastmessage: null
    }
  }) public dialogueData?: {
      showname: string,
      recvmobile: string,
      islogin: number,
      lastmessage: any
  }
  @Prop({ default: false }) public hasSelect?: boolean
  @Prop({ default: 0 }) public index?: number
  get lastMessage() {
    return this.dialogueData?.lastmessage ? this.dialogueData.lastmessage : null
  }
  get lastMessageTime() {
    return this.lastMessage ? timeFormatTime(this.lastMessage.messagetimestamp) : ''
  }
  get dialogueName() {
    if (this.dialogueData) {
      if (this.dialogueData.showname) {
        return this.dialogueData.showname
      } else if (this.dialogueData.recvmobile) {
        const strArr = this.dialogueData.recvmobile.split('')
        strArr.splice(-8, 4, '*', '*', '*', '*')
        return strArr.join('')
      }
    }
    return ''
  }
  get readStatusMark() {
    const readStatusMarkMap = {
      [READ_STATUS.NOT_READ]: {
        'el-icon-check': true
      },
      [READ_STATUS.READ]: {
        'el-icon-finished': true
      }
    }
    if (this.lastMessage?.fromme && this.lastMessage?.status) {
      return readStatusMarkMap[this.lastMessage.status === READ_STATUS.READ ? READ_STATUS.READ : READ_STATUS.NOT_READ]
    }
    return {}
  }
  get loginStatusMark() {
    const banStatus: { [prop: number]: any } = {
      0: 'el-icon-warning-outline',
      1: 'el-icon-circle-check',
      2: 'el-icon-circle-close'
    }
    const isLogin: number = this.dialogueData?.islogin || 0
    return banStatus[isLogin]
  }
  public setCurrentDialogueIndex() {
    this.$emit('setCurrentDialogueIndex', this.index)
  }
  public translateMessage(str: string) {
    return HTMLEncode(str)
  }
}
